var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlTelephoneFilled = function SvgHtlTelephoneFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.783 14h-.108a11.918 11.918 0 0 1-5.2-1.849 11.742 11.742 0 0 1-3.61-3.618 11.917 11.917 0 0 1-1.848-5.22A1.2 1.2 0 0 1 3.215 2h1.806a1.2 1.2 0 0 1 1.2 1.036c.077.578.219 1.146.423 1.692A1.2 1.2 0 0 1 6.376 6l-.765.765a9.635 9.635 0 0 0 3.613 3.613l.765-.765a1.2 1.2 0 0 1 1.271-.271 7.732 7.732 0 0 0 1.692.422 1.2 1.2 0 0 1 1.036 1.222v1.806A1.202 1.202 0 0 1 12.783 14Z"
  })));
};
export default SvgHtlTelephoneFilled;